// extracted by mini-css-extract-plugin
export default {"UserPanel":"UserPanel_UserPanel__rN969"};